import React, { FC, memo } from 'react'

import { Accordion } from '@Components/CMS/Accordion'
import { AccordionSidePaneProps } from '@Components/CMS/AccordionSidePane'
import { SizeGuideWrapper, StyledAccordionSidePane } from '@Components/Product/SizeGuide/styledElements'
import { BlockTypeWithGlobal, Maybe } from '@Generated/graphql'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { useMParticle } from '@Globals/MParticle/useMParticle'

type Variant = 'accordion' | 'accordion-side-pane'

interface ProductSizeGuideProps {
  blocks: Maybe<BlockTypeWithGlobal[]>
  id: string
  title: string
  variant?: Variant
}

export const ProductSizeGuide: FC<ProductSizeGuideProps> = memo(({ blocks, children, id, title, variant = 'accordion' }) => {
  const components = useBlockComponents(blocks || [], id)
  const { otherEvent } = useMParticle()

  if (!title || components.length === 0) {
    return null
  }

  const AccordionComponent = variant === 'accordion' ? Accordion : StyledAccordionSidePane

  const extraProps: Partial<AccordionSidePaneProps> = variant !== 'accordion'
    ? {
      disableResponsive: true,
      fullScreenOnMobile: true,
    }
    : {}

  return (
    <SizeGuideWrapper>
      <AccordionComponent
        color="white"
        header={title}
        onOpen={() => {
          otherEvent({
            eventName: 'pp_guide_info_link_open',
            attributes: {},
          })
        }}
        {...extraProps}
      >
        {components}
        {children}
      </AccordionComponent>
    </SizeGuideWrapper>
  )
})
